<template>
  <div class="pa-6">
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined flat>
          <v-card-text class="pa-4">
            <h3 class="primary--text mb-4">{{ $t('guest.personalInfo.title') }}</h3>
            <v-form ref="form" :disabled="loading">
              <label>{{ $t('guest.personalInfo.firstName') }}</label>
              <v-text-field
                v-model="form.firstName"
                outlined
                dense
                single-line
                validate-on-blur
                :rules="[v => (v && v.length <= 100) || $t('validation.maxChar')]"
              ></v-text-field>
              <label>{{ $t('guest.personalInfo.lastName') }}</label>
              <v-text-field
                v-model="form.lastName"
                outlined
                dense
                single-line
                validate-on-blur
                :rules="[v => (v && v.length <= 100) || $t('validation.maxChar')]"
              ></v-text-field>
              <label>{{ $t('guest.personalInfo.phone') }}</label>
              <v-text-field
                v-model="form.phone"
                outlined
                dense
                single-line
                validate-on-blur
                :rules="[v => !v || v.length <= 20 || $t('validation.maxChar')]"
              ></v-text-field>
              <label>{{ $t('guest.personalInfo.email') }}</label>
              <v-text-field
                :value="form.email"
                outlined
                dense
                single-line
                disabled
              ></v-text-field>
              <label>{{ $t('guest.personalInfo.language') }}</label>
              <v-select
                v-model="form.language"
                :items="languages"
                item-text="label"
                item-value="value"
                outlined
                dense
                single-line
              ></v-select>
              <div class="d-flex mt-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  depressed
                  :disabled="submitLoading"
                  :loading="submitLoading"
                  @click="submit"
                >
                  {{ $t('guest.personalInfo.save') }}
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getGuestProfile, updateGuestProfile } from '@/services/guest'

export default {
  name: 'GuestPersonalInfo',
  data () {
    return {
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        language: ''
      },
      loading: true,
      submitLoading: false
    }
  },
  computed: {
    languages () {
      return (this.$store.state.languages || []).map(lang => ({
        value: lang,
        label: this.$t(`languages.${lang}`)
      }))
    }
  },
  async created () {
    await this.fetchProfile()
  },
  methods: {
    async fetchProfile () {
      this.loading = true
      try {
        const { data } = await getGuestProfile()
        this.form.firstName = data.firstName
        this.form.lastName = data.lastName
        this.form.phone = data.phone
        this.form.email = data.email
        this.form.language = data.language
      } catch (e) {}
      this.loading = false
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      this.submitLoading = true
      try {
        await updateGuestProfile({
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          phone: this.form.phone,
          language: this.form.language
        })
        await this.$store.dispatch('setSuccessNotification', this.$t('guest.personalInfo.saved'))
        await this.$store.dispatch('fetchUserData')
      } catch (e) {}
      this.submitLoading = false
    }
  }
}
</script>
